import {Switch, Typography, Tooltip, IconButton} from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Grid from '@material-ui/core/Grid';
import {i18n2} from 'features/i18n/i18n';
import {Field} from 'formik';
import {TextField} from 'formik-material-ui';
import React, {useEffect} from 'react';

const EmailGroup = ({formikProps}) => {
  const enabled = formikProps.values.validateEmail;
  const anonimo = formikProps.values.anonimo;
  const smtpUser = formikProps.values.smtpUser;
  const port = formikProps.values.port;
  const useStartTls = formikProps.values.useStartTls;
  const useSsl = formikProps.values.useSsl;

  useEffect(() => {
    if (!enabled) return;

    // Si ambos están activos → priorizar STARTTLS
    if (useStartTls && useSsl) {
      formikProps.setFieldValue('useSsl', false);
    }

    // Si hay usuario y no es anónimo → forzar STARTTLS si nada activo
    if (!anonimo && smtpUser && !useStartTls && !useSsl) {
      formikProps.setFieldValue('useStartTls', true);
    }

    // Si puerto 465 → sugerir SSL
    if (port === 465 && !useSsl) {
      formikProps.setFieldValue('useSsl', true);
      formikProps.setFieldValue('useStartTls', false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, anonimo, smtpUser, port, useStartTls, useSsl]);

  return (
    <Grid container spacing={2}>
      <Grid item md={3} xs={12}>
        <Field
          component={Switch}
          name="validateEmail"
          label={i18n2._('Habilitar notificaciones por email')}
          onChange={(e) => {
            formikProps.setFieldValue('validateEmail', e.target.checked);
          }}
          checked={enabled}
        />
        <p style={{display: 'inline'}}>
          {i18n2._('Habilitar notificaciones por email')}
        </p>
      </Grid>
      <Grid item md={3} xs={12}>
        <Field
          component={Switch}
          name="anonimo"
          label={i18n2._('Usar modo anónimo')}
          onChange={(e) => {
            formikProps.setFieldValue('anonimo', e.target.checked);
          }}
          checked={anonimo}
          disabled={!enabled}
        />
        <p style={{display: 'inline'}}>{i18n2._('Modo anónimo')}</p>
      </Grid>
      <Grid item md={3} xs={12}>
        <Field
          component={Switch}
          name="useStartTls"
          label={i18n2._('Usar STARTTLS')}
          onChange={(e) => {
            formikProps.setFieldValue('useStartTls', e.target.checked);
            if (e.target.checked) formikProps.setFieldValue('useSsl', false);
          }}
          checked={formikProps.values['useStartTls']}
          disabled={!enabled}
        />
        <Typography display="inline">{i18n2._('Usar STARTTLS')}</Typography>
        <Tooltip
          title={i18n2._(
            'Recomendado para el puerto 587. Requerido por la mayoría de los servidores modernos.',
          )}>
          <IconButton size="small" style={{padding: 4}}>
            <InfoOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Grid>
      <Grid item md={3} xs={12}>
        <Field
          component={Switch}
          name="useSsl"
          label={i18n2._('Usar SSL')}
          onChange={(e) => {
            formikProps.setFieldValue('useSsl', e.target.checked);
            if (e.target.checked)
              formikProps.setFieldValue('useStartTls', false);
          }}
          checked={formikProps.values['useSsl']}
          disabled={!enabled}
        />
        <Typography display="inline">{i18n2._('Usar SSL')}</Typography>
        <Tooltip
          title={i18n2._('Recomendado para el puerto 465 (SSL implícito).')}>
          <IconButton size="small" style={{padding: 4}}>
            <InfoOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Grid>
      <Grid item md={3} xs={12}>
        <Field
          name="port"
          component={TextField}
          label={i18n2._('Puerto SMTP')}
          fullWidth
          required={enabled}
          variant="outlined"
          disabled={!enabled}
          size={'small'}
        />
      </Grid>
      <Grid item md={3} xs={12}>
        <Field
          name="host"
          component={TextField}
          label={i18n2._('Servidor SMTP')}
          fullWidth
          required={enabled}
          variant="outlined"
          disabled={!enabled}
          size={'small'}
        />
      </Grid>
      <Grid item md={3} xs={12}>
        <Field
          name="emailFrom"
          component={TextField}
          label={i18n2._('Dirección remitente (From)')}
          fullWidth
          required={enabled}
          variant="outlined"
          disabled={!enabled}
          size={'small'}
        />
      </Grid>

      <Grid item md={3} xs={12}>
        <Field
          name="smtpUser"
          component={TextField}
          label={i18n2._('SMTP Usuario')}
          fullWidth
          variant="outlined"
          disabled={!enabled || anonimo}
          size={'small'}
        />
      </Grid>
      <Grid item md={3} xs={12}>
        <Field
          name="smtpPassword"
          component={TextField}
          label={i18n2._('SMTP Contraseña')}
          type="password"
          fullWidth
          variant="outlined"
          disabled={!enabled || anonimo}
          size={'small'}
        />
      </Grid>
      {smtpUser && !anonimo && !useStartTls && !useSsl && (
        <Grid item xs={12}>
          <Typography style={{color: 'red'}}>
            Se recomienda activar STARTTLS cuando se usa autenticación SMTP.
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default EmailGroup;
